import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

export const SET_LISTA_TIPO_EXAME = "setListTipoExame"
export const SET_MESSAGE_ALERT = 'setMensagem'

const actions = {

    //#region  tipo_exame
    async create_tipo_exame(context, value) {
        let message = await ApiService.post('tipo_exame', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_tipo_exame(context, value) {
        const id = value.id
        delete(value.id)
        let message = await ApiService.put('tipo_exame/atualizar/' + id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async bloquear_tipo_exame(context, value) {
        let message = await ApiService.get('tipo_exame/bloquear/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async desbloquear_tipo_exame(context, value) {
        let message = await ApiService.get('tipo_exame/desbloquear/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async delete_tipo_exame(context, value) {
        let message = await ApiService.get('tipo_exame/deletar/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async listar_tipo_exames(context, params) {
        await ApiService.get('tipo_exame')
            .then(response => context.commit(SET_LISTA_TIPO_EXAME, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async listar_tipo_exames_ativos(context, params) {
        await ApiService.get('tipo_exame/ativos')
            .then(response => context.commit(SET_LISTA_TIPO_EXAME, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async pesquisar_tipo_exames(context, params) {
        await ApiService.get('tipo_exame/filtro/' + params)
            .then(response => context.commit(SET_LISTA_TIPO_EXAME, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    //#endregion




};

const getters = {};

const mutations = {
    [SET_LISTA_TIPO_EXAME](state, value) {
        state.lista_tipo_exames = value
    },


    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {
            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
};

const state = {
    lista_tipo_exames: [],
    mensagem_alert: "",


};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};